import { render, staticRenderFns } from "./DeptPicker.vue?vue&type=template&id=20e57e1b&scoped=true&"
import script from "./DeptPicker.vue?vue&type=script&lang=js&"
export * from "./DeptPicker.vue?vue&type=script&lang=js&"
import style0 from "./DeptPicker.vue?vue&type=style&index=0&id=20e57e1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e57e1b",
  null
  
)

export default component.exports